import ProgressGoalsList from './ProgressGoalsList.component';

export default ProgressGoalsList;
